import { Injectable } from "@angular/core";
import * as S3 from 'aws-sdk/clients/s3';
import { ToastsManager } from "ng2-toastr";
import { decode } from 'jsonwebtoken';
import { HttpClient } from "../shared/wrappers/HttpClient";

interface S3Data {
    Bucket: string;
    BucketUrl: string;
    credentials: {
        accessKeyId: string;
        secretAccessKey: string;
        region: string;
    }
}

@Injectable()
export class AwsService {
    private awsEndPoint = "/aws-s3";
    public S3Data: S3Data;

    constructor(public toastr:ToastsManager, private http: HttpClient) {
        (async () => {
            await this.getS3Credentials();
        })()
    }

    async getS3Credentials(): Promise<void> {
        let response = await this.http.post(this.awsEndPoint, {});
        response = (response.slice(10)).slice(0, -10);
        const decryptedDataFirstStep = window.atob(response);
        const decryptedDataSecondStep = window.atob(decryptedDataFirstStep);
        const decryptedDataThirdStep = window.atob(decryptedDataSecondStep);
        const decryptedJwt = decode(decryptedDataThirdStep);
        this.S3Data = decryptedJwt;
    }

    getPuclicPath(): string {
        return this.S3Data.BucketUrl;
    }

    async getBucket(){
        return new S3(this.S3Data.credentials);
    }

    async uploadfile(file, id, name='') {
        const params = {
          Bucket: this.S3Data.Bucket,
          Key: `${id}/${name ? name : file.name}`,
          Body: file,
          ACL: 'public-read'
        };

        try {
          this.toastr.warning(`Realizando upload do arquivo ${file.name} ...`,'Upload de Arquivo');
          await (await this.getBucket()).upload(params).promise();
          this.toastr.success(`O arquivo "${file.name}" foi enviado com sucesso.`);
          return true;
        } catch (error) {
          this.toastr.error(`Erro ao enviar o arquivo ${file.name}.`);
          return false;
        }
    }

   async getFiles(id){
      const params = {
        Bucket: this.S3Data.Bucket,
        Prefix:  `${id}/`
      }

      try{
        let response = await (await this.getBucket()).listObjects(params).promise();
        return response.Contents;
      }catch(err){
        this.toastr.error(`Erro ao listar arquivos do servidor.`);
        return [];
      }
    }

    async deleteFile(name){
      let params = {
        Bucket: this.S3Data.Bucket,
        Key: `${name}`
       };

       try {
          await (await this.getBucket()).deleteObject(params).promise();
       } catch (error) {
          this.toastr.error(`Erro ao remover arquivo`);
       }

    }

    async download(name){
      let params = {
        Bucket: this.S3Data.Bucket,
        Key: `${name}`
      };
      return (await this.getBucket()).getSignedUrl('getObject',params);
    };
}



// WEBPACK FOOTER //
// ./src/app/services/aws.service.ts